module.exports = __webpack_public_path__ + "images/marketing/hero3.jpg";